module.exports = __webpack_public_path__ + "static/media/instala.91fa6498.png";